// Featured collection slider
const featured_col_Swiper = new Swiper(".featured_col_Swiper", {
  slidesPerView: "auto",
  spaceBetween: 0,
  slidesPerGroup: 2,
  freeMode: true,
  pagination: {
    el: ".featured_col_Swiper .swiper-pagination",
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.featured_col_Swiper .swiper-button-next',
    prevEl: '.featured_col_Swiper .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
      freeMode: false
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 10,
      freeMode: false
    },
  },
});

// No need as we trigger it when the tab is clicked.
// function featured_col_Swiper2(){
//   const featured_col_Swiper2 = new Swiper(".featured_col_Swiper2", {
//     slidesPerView: "auto",
//     spaceBetween: 0,
//     slidesPerGroup: 2,
//     freeMode: true,
//     pagination: {
//       el: ".featured_col_Swiper2 .swiper-pagination",
//       clickable: true,
//     },
//     // Navigation arrows
//     navigation: {
//       nextEl: '.featured_col_Swiper2 .swiper-button-next',
//       prevEl: '.featured_col_Swiper2 .swiper-button-prev',
//     },
//     breakpoints: {
//       768: {
//         slidesPerView: 4,
//         spaceBetween: 10,
//         freeMode: false
//       },
//       1024: {
//         slidesPerView: 5,
//         spaceBetween: 10,
//         freeMode: false
//       },
//     },
//   });

// }
// featured_col_Swiper2();

// announcement slideShow

const announcement_text_slider = new Swiper('.announcement_text_slider', {
  autoHeight: false,
  centeredSlides: true,
  freeMode: false,
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    reverseDirection: true,
  },
});

$(".announcement_text_slider").each(function(elem, target){
    var swp = target.swiper;
    $(this).hover(function() {
        swp.autoplay.stop();
    }, function() {
        swp.autoplay.start();
    });
});

// Banner slideShow
var $mySwiper = $('.mySwiper');
const swiper = new Swiper('.mySwiper', {
  autoHeight: true,
  effect: "fade",
  loop: $mySwiper.data("loop"),
  slidesPerView: 1,
  autoplay: {
    delay: parseInt($mySwiper.data('swiper-autoplay')),
    disableOnInteraction: false,
  },

  // If we need pagination
  pagination: {
    el: '.mySwiper .swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.mySwiper .swiper-button-next',
    prevEl: '.mySwiper .swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.mySwiper .swiper-scrollbar',
  },
  breakpoints: {
    1025: {
      autoplay: {
        delay: parseInt($mySwiper.data('swiper-autoplay')),
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }
    }
  },
  on: {
    reachEnd: function() {
      if(!$mySwiper.data("loop")) swiper.autoplay = false;
    }
  }
});

// Multicolumn slider
const multicolumnSwiper = document.querySelector('.multicolumn_Swiper');
let space = '';
if(multicolumnSwiper) {
  space = parseInt(multicolumnSwiper.getAttribute('data-space'));
}
if(!space){
  space = 0;
}
const multicolumn_Swiper = new Swiper(".multicolumn_Swiper", {
  slidesPerView: "auto",
  spaceBetween: space,
  slidesPerGroup: 2,
  freeMode: true,
  pagination: {
    el: ".multicolumn_Swiper .swiper-pagination",
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.brand_logos_container .swiper-button-next',
    prevEl: '.brand_logos_container .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 15,
      freeMode: false
      //        loop: true,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 24,
      freeMode: false
    },
  },
});

/*multicolumn_Swiper.on('slideChange', function () {
//  console.log(this.activeIndex + 1+"/"+this.imagesLoaded );
//    console.log(`[aria-label="${this.activeIndex + 1+" / "+this.imagesLoaded }"]`);
//   const avtiveSlide = document.querySelector(`.brand_logos  .swiper-slide-next`);
  const avtiveSlide = document.querySelector(`[aria-label="${this.activeIndex + 1+" / "+this.imagesLoaded }"]`);
  avtiveSlide.classList.add("check");
  avtiveSlide.style.marginLeft  = (55 / this.activeIndex)*this.activeIndex+this.activeIndex*1.2+"px";

});*/

// main-collection-page_Swiper
var main_collection_page_Swiper_elem = document.querySelector('.main-collection-page_Swiper');
var main_collection_page_Swiper_mob_slide = 1;
if(main_collection_page_Swiper_elem){
  main_collection_page_Swiper_mob_slide = parseInt(main_collection_page_Swiper_elem.dataset.slideMob);
}
const main_collection_page_Swiper = new Swiper(".main-collection-page_Swiper", {
  // slidesPerView: main_collection_page_Swiper_mob_slide,
  slidesPerView: 2,
  spaceBetween: 10,
//     loop: true,
  pagination: {
    el: ".main-collection-page_Swiper .swiper-pagination",
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.main-collection-page_Swiper .swiper-button-next',
    prevEl: '.main-collection-page_Swiper .swiper-button-prev',
  },
  // And if we need scrollbar
  scrollbar: {
    el: '.main-collection-page_Swiper .swiper-scrollbar',
    type: "progressbar",
  },
  breakpoints: {
    1024: {
      slidesPerView: 7,
      spaceBetween: 10,
//              loop: true,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
//              loop: true,
    },
     640: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
});

//image and only text slider
const text_slider = new Swiper('.text_slider', {
  effect: "slide",

  // If we need pagination
  pagination: {
    el: '.text_slider .swiper-pagination',
    clickable: true,
    type: 'bullets',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.text_slider .swiper-button-next',
    prevEl: '.text_slider .swiper-button-prev',
  },

  // And if we need scrollbar
  //   scrollbar: {
  //     el: '.text_slider .swiper-scrollbar',
  //   },
});

// footer accordion

var acc = document.getElementsByClassName("footer-block__heading");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// always page go top after page load
//  document.body.scrollTop = document.documentElement.scrollTop = 0;

// featured collection tab
jQuery(function($){
  $('.col_tab li').on('click', function(){


    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    var trigger = $(this).attr('triggervalue');

    const featured_col_Swiper = new Swiper("."+trigger, {
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesPerGroup: 2,
      freeMode: true,
      pagination: {
        el: "."+trigger+" .swiper-pagination",
        clickable: true,
      },
      // Navigation arrows
      navigation: {
        nextEl: "."+trigger+" .swiper-button-next",
        prevEl: "."+trigger+" .swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 10,
          freeMode: false
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 10,
          freeMode: false
        },
      },
    });

    $('.'+trigger).siblings().removeClass('active');
    $('.'+trigger).addClass('active');

    setTimeout(function(){ adjustBrandPrice($('.'+trigger)); }, 500);
  });
});

function adjustBrandPrice(element){
    $('.brand-name, .card-information__text',element).removeClass('double_line');
    $('.brand-name, .card-information__text',element).removeClass('single_line');
    $('.price, .swiper-wrapper',element).css('height', 'auto');
    var double_line = false;
    var title_double_line = false;
    $('.brand-name',element).each(function(){
      if($(this).height() > 20){
        double_line = true;
        return false;
      }
    });
    if(double_line){
      $('.brand-name',element).each(function(){
        if($(this).height() <= 20) $(this).addClass('single_line');
        else $(this).addClass('double_line');
      });
    }
    else $('.brand-name',element).removeClass('double_line');

    $('.card-information__text',element).each(function(){
      if($(this).height() > 20){
        title_double_line = true;
        return false;
      }
    });
    if(title_double_line){
      $('.card-information__text',element).each(function(){
        if($('.full-unstyled-link', this).outerHeight() <= 20) $(this).addClass('single_line');
        else $(this).addClass('double_line');
      });
    }
    else $('.card-information__text',element).removeClass('double_line');

    var max_height = 0;
    $('.price',element).each(function(){
      if($(this).height() > max_height) max_height = $(this).height();
    });
    $('.price',element).height(max_height);

    let swiperWrapperHeight = $('.swiper-wrapper', element).height()
    let swiperWrapperHeightValue = swiperWrapperHeight != 0 ? swiperWrapperHeight : 'auto'
    $('.swiper-wrapper', element).height(swiperWrapperHeightValue);
}
$('.swiper').each(function(){
  adjustBrandPrice(this);
});
$(window).resize(function(){
  $('.swiper').each(function(){
    adjustBrandPrice(this);
  });
});

// megamenu
jQuery(function($){
//   $(document).on('click','.mega_parent',function(e){

    $( ".mega_parent" ).mouseenter(function() {

//     e.preventDefault();
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    var targetData = $(this).attr('terget_megamenu');
    $('[data-dropdown='+targetData+']').parents(".mega-menu-section").siblings().removeClass('active');
    $('[data-dropdown='+targetData+']').parents(".mega-menu-section").addClass('active');
    console.log(targetData)
  });


  $( ".dropdown_container" ).mouseleave(function() {
    console.log('leave');
    $(this).parents(".mega-menu-section").removeClass('active');
    var targetData1 = $(this).attr('data-dropdown');
    $('[terget_megamenu='+targetData1+']').removeClass('active');
  });



  // for sticky menu
//   $(document).on('click','.level_1_item ',function(e){
//     e.preventDefault();
  $( ".level_1_item" ).mouseenter(function() {
    var triger_megamenu = $(this).attr('triger_megamenu');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('[data-dropdown='+triger_megamenu+']').parents(".mega-menu-section").siblings().removeClass('active');
    $('[data-dropdown='+triger_megamenu+']').parents(".mega-menu-section").addClass('active');
  });


  $(document).on('click','.humbergerfor_sticky svg',function(e){

    $(this).parent().addClass('open');
    $(".mega-menu-container.do-sticky").addClass('active');
    $('#shopify-section-mega-menu-1').addClass('active');
    $('.main_nav_1').addClass('active');
  });

   $(document).on('click','.humbergerfor_sticky.open svg',function(e){

    $(this).parent().removeClass('open');
    $(".mega-menu-container.do-sticky").removeClass('active');
    $('.mega-menu-section').removeClass('active');
    $('.main_nav_1').removeClass('active');
     $('.level_1_item').removeClass('active');
  });

});


// product description learn more , show more
jQuery(function($){
  $(document).on('click', '.show_more',function(){
    $(this).addClass('hide');
    $(this).siblings('.show_less').removeClass('hide');
    $(this).parents('.des_bottom_div').siblings('.short_des').addClass('hide');
    $(this).parents('.des_bottom_div').siblings('.long_des').removeClass('hide');
    $(this).parents('.bottomImg').removeAttr('style');
  });

  $(document).on('click', '.show_less',function(){
    $(this).addClass('hide');
    $(this).siblings('.show_more').removeClass('hide');
    $(this).parents('.des_bottom_div').siblings('.short_des').removeClass('hide');
    $(this).parents('.des_bottom_div').siblings('.long_des').addClass('hide');
    $(this).parents('.bottomImg').css('height',$(this).parents('.bottomImg').height());
  });
});

// newsletter popup
jQuery(function($){
  var checkNewsletter = function(){
    var date = new Date();
    if(localStorage.getItem('tmx-newsletter') == null || localStorage.getItem('tmx-newsletter') == "undefined" ){
      $("#newsletter-popup").modal({
        fadeDuration: 500
      });
      localStorage.setItem('tmx-newsletter', date );
    }
    else{
      var check_time = new Date(date) - new Date(localStorage.getItem('tmx-newsletter'));
      var ms = check_time % 1000;
      check_time = (check_time - ms) / 1000;
      var days = Math.floor(check_time / 86400);//200 is sec for day set
//       console.log('check_time:- '+check_time);
//       console.log('days:- '+days);
      if(days > 1){
        $("#newsletter-popup").modal({
          fadeDuration: 500
        });
        localStorage.setItem('tmx-newsletter', date );
      }
    }
//      console.log(date);
//     console.log(localStorage.getItem('tmx-newsletter'));
  }

  $(document).ready(function(){
    if($("#newsletter-popup").length > 0) checkNewsletter();
  });

  $(document).on('click', '.false_btn',function(){
    var inputval = $('#first-name').val();
    var emailVal = $('.emailValid').val();
    console.log(inputval);
    if(inputval == "" ){
      $("#valError").addClass('show');
    }
    if(emailVal == "" ){
      $("#lblError").text('Please enter a valid email address.');
    }


//     $(".error-fields").addClass("show");
  });


});


// notify me
//   $(document).on('click', '.notifyme', function(){
//     console.log('click work notify')
//   });


//open qty popup

// $(document).ready(function() {
//   $("a.fancybox").fancybox()
// });
jQuery(function($){
  $(document).on('click', '.popup_minq', function(e){
     e.preventDefault();
    $('.open_popup_minq').addClass('active');
  });

  $(document).on('click', '.open_popup_minq_close', function(e){
     e.preventDefault();
    $(this).parents('.open_popup_minq').removeClass('active');
  });

});

// jQuery(function($){
//   $( document ).ready(function() {
//     function capitalizeFirstLetter(string){
//       return string.charAt(0).toUpperCase() + string.slice(1);
//     }
//     setTimeout(function() {
//       var nameOfYourDog = capitalizeFirstLetter($("[for=bta-field-name_of_your_dog]").text().toLowerCase()).replace(/:/g,'');
//       $('#bta-field-name_of_your_dog').attr("Placeholder", nameOfYourDog);
//       $('#bta-field-comments_about_the_booking').attr("Placeholder", "Comments");
//       var text = capitalizeFirstLetter($("[for=bta-field-dog_breed]").text().toLowerCase()).replace(/:/g,'');
//       $("#bta-field-dog_breed option").each(function(i){
//         if(i == 0){
//         $(this).attr('disabled','disabled');
//           $(this).text(text)
//         }
//       });
//       // var strUser = e.options[e.selectedIndex];
//     },5000);
//   });
// });

var theme = theme || {};
//disable soldout option in product page
jQuery(function($){

  theme.varChangefunc = function(){
    $('body').on('change', '.option1_for_below_input.swatch :radio', function() {
      var thisValue = $(this).attr("value");
      var data_option1 = $(this).attr('data_option1');

      var data_option2 = $(this).attr('data_option2');
      var lastChar2 = data_option2.slice(-1);
      if (lastChar2 == ',') {
        data_option2 = data_option2.slice(0, -1);
      }

      var data_option3 = $(this).attr('data_option3');
      var lastChar3 = data_option3.slice(-1);
      if (lastChar3 == ',') {
        data_option3 = data_option3.slice(0, -1);
      }
      console.log(data_option2);
      var data_option2Array = data_option2.split(",");
      var allOption2 = '';
      $.each(data_option2Array,function(i){
        var triggerOption2 = data_option2Array[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        allOption2 = data_option2Array[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        console.log(i+"-"+data_option2Array[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
        //       $(".option2_for_below_input .input-"+allOption2).siblings("label").addClass('soldout');
        //        $(".option2_for_below_input .input-"+allOption2).siblings("label").removeClass('available');
        $(".option2_for_below_input label").addClass('soldout');
        $(".option2_for_below_input label").removeClass('available');
        $(".option2_for_below_input .input-"+triggerOption2).trigger('click');

        $(".option2_for_below_input .label-"+allOption2).removeClass('soldout');
        $(".option2_for_below_input .label-"+allOption2).addClass('available');
        $(".option2_for_below_input .label-"+triggerOption2).removeClass('soldout');
        $(".option2_for_below_input .label-"+triggerOption2).addClass('available');
      });

      var data_option3Array = data_option3.split(",");
      $.each(data_option3Array,function(i){
        var triggerOption3 = data_option3Array[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        var allOption3 = data_option3Array[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        //       console.log(triggerOption3);
        $(".option3_for_below_input label").addClass('soldout');
        $(".option3_for_below_input label").removeClass('available');
        $(".option3_for_below_input .input-"+triggerOption3).trigger('click');

        $(".option3_for_below_input .label-"+allOption3).removeClass('soldout');
        $(".option3_for_below_input .label-"+allOption3).addClass('available');
        $(".option3_for_below_input .label-"+triggerOption3).removeClass('soldout');
        $(".option3_for_below_input .label-"+triggerOption3).addClass('available');
      });


    });
  }

  //  theme.varChangefunc();

});

  //   new quickview
jQuery(function($){

  $(document).on('click',".quick-view_new", function () {
    console.log(this);
    console.log('click qv');
    var openId = "#qv_"+$(this).attr('data-productid');
    console.log('click qv-'+openId);
    $(openId).show();

var url = window.location.href;
    $.fancybox.open({
            href: "#qv_"+$(this).attr('data-productid'),
            maxWidth: 1040,
            maxHeight: 610,
            fitToView: true,
            width: '75%',
            height: '70%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
        afterShow: function () {
          $("body").addClass('new_quick_view_open');
        },
        afterClose: function () {
           $("body").removeClass('new_quick_view_open');
          $("#qv_"+$(this).attr('data-productid')).removeClass().empty();
          //               $('.qv-product-main-images').slick('unslick');
          //               $('.slider-nav').slick('unslick');
          window.history.replaceState({ }, '',url);
//           $.fancybox.defaults.hash = false;
          $('.open_popup_minq').removeClass('active');
          console.log('close');
        },
        beforeLoad: function () {
          var galleryThumbs= new Swiper(".recomended .qv-product-thumb-images.slider-nav", {
            centeredSlides: false,
            slidesPerView: 4,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass:"swiper-slide-active"
          });

          console.log(galleryThumbs);
          var galleryMain = new Swiper(".recomended .qv-product-main-images", {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            }
//             ,
//             thumbs: {
//               swiper: galleryThumbs
//             }
          });
//           galleryMain.on('slideChangeTransitionStart', function() {
//             galleryThumbs.slideTo(galleryMain.activeIndex);
//           });
//           galleryThumbs.on('transitionStart', function(){
//             galleryMain.slideTo(galleryThumbs.activeIndex);
//           });
        },
      afterLoad: function() {
        setTimeout(function() {
          var galleryThumbs= new Swiper(".fancybox-inner .qv-product-thumb-images.slider-nav", {
            centeredSlides: false,
            slidesPerView: 4,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideActiveClass:"swiper-slide-active"
          });

          console.log(galleryThumbs);
          var galleryMain = new Swiper(".fancybox-inner .qv-product-main-images", {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            }
            ,
            thumbs: {
              swiper: galleryThumbs
            }
          });
          galleryMain.on('slideChangeTransitionStart', function() {
            galleryThumbs.slideTo(galleryMain.activeIndex);
          });
          galleryThumbs.on('transitionStart', function(){
            galleryMain.slideTo(galleryThumbs.activeIndex);
          });
        }, 2500);

      }
    });
  });

});


if(window._swat){
  window._swat.initializeActionButtons(".save-whishlist");
}else{
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function(){ window._swat.initializeActionButtons(".save-whishlist"); });
}

//Swym boost collection wishlist toggle Script start
function removeClass(evnt) {
  $(document).click('.swym-button', function(e){
    $(e.target).removeClass('disabled swym-added swym-adding swym-removing');
    $(e.target).parents('.grid__item').find('.swym-heart').removeClass('disabled swym-added swym-adding swym-removing');
  });
}
if (!window._swat) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(removeClass);
} else {
  removeClass();
}
setInterval(function() {
  $('.boost-pfs-filter-products .grid__item').each(function( index ) {
    if($(this).find('.swym-button').hasClass("swym-added")){
      $(this).find('.swym-heart').addClass('disabled swym-added swym-adding swym-removing');
    }

  });
}, 1000);

//Swym boost collection wishlist toggle Script end

// $(document).click(".card-information__text a",function(e){
  $(window).load(function(){
//   e.preventDefault();
//   var prodctLink = $(e.target).attr('href');
  var collection_title = $("#CollectionProductGrid").attr('title');
  var collection_url = $("#CollectionProductGrid").attr('url');
  var PrebreadcrumbObject = JSON.parse(localStorage.getItem('breadcrumbCollection'));
  var previousColDetails = {"prevTitle":PrebreadcrumbObject.name,"prevUrl":PrebreadcrumbObject.url};
  localStorage.setItem('previousBreadcrumbCollection', JSON.stringify(previousColDetails) );
  var collection = {"template": $('.template_name_js').attr('template'), "name":collection_title , "url":collection_url};
  localStorage.setItem('breadcrumbCollection', JSON.stringify(collection) );

})
var breadcrumbObject = JSON.parse(localStorage.getItem('breadcrumbCollection'));
var previousBreadcrumbCollectionObje = JSON.parse(localStorage.getItem('previousBreadcrumbCollection'));
if( breadcrumbObject != null ){
  if(breadcrumbObject.template == "collection"){
    var breadcrumbCol = document.getElementById('collection-breadcrumb');
    if ($.inArray(breadcrumbObject.name, currentCollectionTitle) != -1)
    {
      console.log(currentCollectionTitle);
      breadcrumbCol.text = breadcrumbObject.name;
      breadcrumbCol.setAttribute("href", breadcrumbObject.url);
      document.querySelector(".hide_collection_breadcrumb").style.display = "inline-block";
    }else{
      console.log("notfound");
      document.querySelector(".hide_collection_breadcrumb").style.display = "none";
//       console.log(previousBreadcrumbCollectionObje);
//       breadcrumbCol.text = previousBreadcrumbCollectionObje.prevTitle;
//       breadcrumbCol.setAttribute("href", previousBreadcrumbCollectionObje.prevUrl);
    }

  }
}

jQuery(function($){
  setTimeout(function() {
    $('.search.search-modal__form').attr("action",'/search');

  }, 7000);

  var v = document.querySelector(".search__input.field__input");
  v.addEventListener("focus", function(e){
    e.currentTarget.parentElement.classList.add('input-focus');
    e.currentTarget.setAttribute('placeholder', 'Search keyword');
  }, true);
  v.addEventListener("blur", function(e){
    e.currentTarget.parentElement.classList.remove('input-focus');
    e.currentTarget.setAttribute('placeholder', 'Find something');
  }, true);
});

document.querySelectorAll('.event-columns-slider').forEach(function(elem){
  var section_id = elem.getAttribute('data-section-id');
  const event_page_Swiper = new Swiper('.event-columns-slider.column-slider-'+section_id, {
    slidesPerView: 'auto',
    spaceBetween: 10,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next-'+section_id,
      prevEl: '.swiper-button-prev-'+section_id,
    },
    breakpoints: {
      1200: {
        slidesPerView: elem.getAttribute('data-per-row'),
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
      750: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
  });
});

if(document.querySelectorAll('.popup-link').length > 0){
  document.querySelectorAll('.popup-link').forEach(function(e){
    e.onclick = function(){
      var block_id = e.getAttribute('data-block-id');
      document.querySelector('.block-popup-content.content-'+block_id).classList.add('active');
      document.querySelector('body').classList.add('overflow-hidden');
    }
  });

  document.querySelectorAll('.block-popup-close').forEach(function(e){
    e.onclick = function(){
      document.querySelector('.block-popup-content.active').classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  });
}

$('.block-popup-content').click(function(e){
  var container = $(".block-popup-inner");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.block-popup-content.active').removeClass('active');
    $('body').removeClass('overflow-hidden');
  }
});
$('.internal_anchor_link').click(function(evt){
  evt.preventDefault();
  var block_id = $(this).attr('href');
  var sticky_bar_height = $('sticky-header').height();
  var section_top = $(block_id).offset().top - sticky_bar_height - 30;
  $('html, body').animate({
    scrollTop: section_top
  }, 500);
});

//Login
$('#CustomerEmail, #CustomerPassword').on('keyup', function() {
  if($(this).val() != '' && $('#CustomerPassword').val() != '') {
    $('.button').removeAttr('disabled');
  } else {
    $('.button').attr("disabled", true);
  }
});

//Login Toggle Password
const togglePassword = document.querySelector('#togglePassword');
const password = document.querySelector('#CustomerPassword');
const email = document.querySelector('#CustomerEmail');

if(togglePassword) {
  togglePassword.addEventListener('click', function (e) {
    // toggle the type attribute
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    // toggle the eye slash icon
    this.classList.toggle('show-password');
  });
}
if(password) {
  password.addEventListener("keyup", function() {
    if (password.value == "") {
      togglePassword.classList.add('disabled');
      password.closest('.field').classList.remove('active');
    } else {
      togglePassword.classList.remove('disabled');
      password.closest('.field').classList.add('active');
    }
  });
}

// //Account Page
var currentUrl = window.location.pathname;
// Select all the links in the navigation menu
var navLinks = document.querySelectorAll('[data-tab-value]');

// Loop through the links and check if their href attribute matches the current URL
if(navLinks) {
  for (var i = 0; i < navLinks.length; i++) {
    // navLinks.forEach(content => content.classList.remove('active'));
    var navlink = navLinks[i].getAttribute('href');
    if(window.location.search == ''){

      if(navlink === currentUrl) {
        navLinks[i].classList.add('active');
      } else {
        navLinks[i].classList.remove('active');
      }
      if(window.location.pathname == '/account') {
        if(navlink.split("?")[1] == "view=order_records") {
          navLinks[i].classList.add('active');
        } else {
          navLinks[i].classList.remove('active');
        }
        document.querySelector('.customer_dropdown__tigger.mobile_tabs').classList.add('only-mobile-hide');
        document.querySelector('.customer__account-detail').classList.add('only-mobile-hide');
        document.querySelector('.customer__info-wrapper').classList.remove('only-mobile-hide');
      }
      if(window.location.pathname == '/account/addresses') {
        document.querySelector('.customer_dropdown__tigger.mobile_tabs').classList.remove('only-mobile-hide');
        document.querySelector('.customer__account-detail').classList.remove('only-mobile-hide');
        document.querySelector('.customer__info-wrapper').classList.add('only-mobile-hide');
      }
    } else {
      if(navlink === currentUrl + window.location.search) {
        navLinks[i].classList.add('active');
      } else {
        navLinks[i].classList.remove('active');
      }
      if(window.location.pathname == '/account' && !window.location.search.includes('analytics_trace_id')) {
        document.querySelector('.customer_dropdown__tigger.mobile_tabs').classList.remove('only-mobile-hide');
        document.querySelector('.customer__account-detail').classList.remove('only-mobile-hide');
        document.querySelector('.customer__info-wrapper').classList.add('only-mobile-hide');
      } else {
        document.querySelector('.customer_dropdown__tigger.mobile_tabs').classList.add('only-mobile-hide');
        document.querySelector('.customer__account-detail').classList.add('only-mobile-hide');
        document.querySelector('.customer__info-wrapper').classList.remove('only-mobile-hide');
      }
      if(window.location.pathname == '/account/addresses') {
        document.querySelector('.customer_dropdown__tigger.mobile_tabs').classList.add('only-mobile-hide');
        document.querySelector('.customer__account-detail').classList.add('only-mobile-hide');
        document.querySelector('.customer__info-wrapper').classList.remove('only-mobile-hide');
      }
    }

    if(window.location.search.includes('analytics_trace_id')) {
      if(navlink.split("?")[1] == "view=order_records") {
        navLinks[i].classList.add('active');
      } else {
        navLinks[i].classList.remove('active');
      }
    }
  }
}

// Account page orderList
const orderList = document.getElementById('order-list');
const model = document.querySelector('.order__popup-model')
if(orderList){
  orderList.addEventListener('click', (event) => {
  // Obtain the order ID from the selected row
  const selectedRow = event.target.closest('#RowOrder');
  const orderId = selectedRow.dataset.orderid;

  // Call the fetch() function with the order ID as a parameter
  fetch(`${orderId}?view=alternate`)
    .then(response => response.text())
    .then(orderData => {
      // Handle the response for the selected order
      // console.log(orderData);
      document.body.classList.add('order-popup-open');
      model.querySelector('.order__detail-wrapper').innerHTML = orderData;
      model.style.display = "flex";
    });
  });
  model.querySelector('.close').addEventListener('click', closePopup);
  model.addEventListener('click', function(e) {
    if(e.target == model) {
      closePopup();
    }
  });
}
function closePopup() {
  model.style.display = "none";
  document.body.classList.remove('order-popup-open');
}


// on load selected tab mobile display

const selected_tab = document.querySelector('.customer.account .tab-list__tab .tab.active');
let contact_dropdown__tiggers = document.querySelector('.customer_dropdown__tigger .trigger__inner');
const customer_mobile_tabss = document.querySelector('.customer_tab_list_mobile');

if(selected_tab) {
  contact_dropdown__tiggers.querySelector('p').innerHTML = selected_tab.textContent;
  customer_mobile_tabss.querySelector(`input[value="${selected_tab.textContent.trim(' ')}"]`).checked = true
}
//store gallary slider

const store_gallary_swiper = new Swiper(".store_gallary__inner", {
  slidesPerView: 1.2,
  spaceBetween: 16,
  pagination: {
    el: ".store_gallary__inner .swiper-pagination",
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper_block_gallary .swiper-button-next',
    prevEl: '.swiper_block_gallary .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 16,
    },
  },
});
